import React, { memo } from "react";

const SearchPrincipalFilter = memo((props) => {
  const { origem, setFilters } = props;

  return <div>FILTER</div>;
});

export default SearchPrincipalFilter;
